import { MAP_TOKEN } from '../../../../../components/react-map-gl/consts';
import { StaticMapBullet } from './static-map-bullet/static-map-bullet';
import styles from './cover-static-map.module.scss';
import Image from 'next/image';
import cn from 'classnames';
import React from 'react';

type Props = {
  className?: string;
  title: string;
  lat: number;
  lng: number;
};

export const CoverStaticMap = ({ className, lng, lat, title }: Props) => {
  return (
    <div className={cn(styles.coverStaticMapBox, className)}>
      <Image
        className={styles.staticMap}
        alt={`${title} map`}
        height={350}
        width={1280}
        src={`https://api.mapbox.com/styles/v1/ben-yad2/ck3zr0kkp01ku1crubwpp93s6/static/${lng},${lat},14,0.00,0.00/1280x350?access_token=${MAP_TOKEN}`}
      />
      <div className={styles.bulletBox}>
        <StaticMapBullet text={title} />
      </div>
    </div>
  );
};
